module.exports = __webpack_public_path__ + "static/media/Icon-awesome-paper-plane-send.c5482bc5.svg";